<db-dialog-wrapper [dialog]="this" [width]="'488px'">
  <div class="db-available">
    <div class="db-available__header" [innerHTML]="header"></div>
    <div class="db-available__message">
      <p [innerHTML]="message"></p>
    </div>
  </div>
</db-dialog-wrapper>
